module.exports = __webpack_public_path__ + "img/profile-style-img2.21d72357.png";